module.exports = __webpack_public_path__ + "static/media/image_29.9699ad60.png";